import Resource from './Resource';

class VisitScript extends Resource {
	constructor() {
		super('master/script');
	}

	// The controller answers with the tracking snippet as a plain string inside the standard
	// {error, data} envelope, so unwrap it here rather than at each caller.
	getScript(): Promise<string> {
		return this._getRequest('', { methodName: 'getScript' }).then(res => res.data.data);
	}
}

export default new VisitScript();
